module.exports = __webpack_public_path__ + "static/media/warning-gray-hexagan.9fdb06d1.svg";